<template lang="pug">
div
  v-row(no-gutters)
    v-col(cols="12" sm="5")
      div.text-lg.font-medium.neutral700--text.mt-8 {{ $t('service_details') }}
      div.text-sm.neutral500--text {{ $t('service_details_desc') }}

      div.text-md.font-medium.neutral700--text.mt-8 {{ $t('service_name') }}
      v-text-field.text-md.font-normal.mt-2.round-xl(v-model="name" :placeholder="$t('service_name_placeholder')" outlined :rules="rules.not_empty" dense height="48" hide-details="auto")

  div.text-md.font-medium.neutral700--text.mt-8 {{ $t('display_service_fee') }}
  v-row(no-gutters)
    v-col(cols="12" sm="6")
      v-radio-group(v-model="displayServiceFee")
        v-radio(:value="false" color="neutral700")
          template(v-slot:label)
            div.text-md.font-normal.neutral700--text {{ $t('no') }}
        v-radio(:value="true" color="neutral700")
          template(v-slot:label)
            div.text-md.font-normal.neutral700--text {{ $t('yes') }}

      v-expand-transition
        v-card.round-lg.neutral300.pa-4(v-if="displayServiceFee" flat)
          div.text-xs.font-semibold {{ $t('service_fee_amount') }}
          v-row.mt-2(no-gutters align="center")
            v-col.pr-1(cols="4")
              v-select.text-md.font-normal.round-xl(v-model="priceType" :items="types" item-text="text" item-value="value" background-color="basic100" outlined :rules="rules.not_empty_select" dense hide-details @change="priceDisplay = []")
                template(v-slot:append)
                  eva-icon(name="chevron-down-outline" width="20" height="20" style="margin-top: 2px" :fill="$colors.basic700")
            v-col.pl-1
              v-text-field.text-md.font-normal.round-xl.inputNumber(v-model="priceDisplay[0]" placeholder="30" type="number" :prefix="$currency.symbol" background-color="basic100" outlined :rules="rules.has_quantity" dense hide-details)
            template(v-if="priceType === 'range'")
              v-col.shrink.px-1
                v-icon(color="primary" small) mdi-minus
              v-col
                v-text-field.text-md.font-normal.round-xl.inputNumber(v-model="priceDisplay[1]" placeholder="30" type="number" :prefix="$currency.symbol" background-color="basic100" outlined :rules="rules.has_quantity" dense hide-details)
  
  v-row(no-gutters)
    v-col(cols="12" sm="5")
      div.text-md.font-medium.neutral700--text.mt-8 {{ $t('service_description') }}
      v-textarea.text-md.font-normal.mt-2.round-xl(v-model="description" :placeholder="$t('service_description_placeholder')" outlined dense hide-details="auto")

      div.text-md.font-medium.neutral700--text.mt-8 {{ $t('service_duration') }}
      div.d-flex.align-center
        div(style="width: 60px")
          v-text-field.text-md.font-normal.mt-2.round-xl.inputNumber.inputText(v-model="durationValue" placeholder="30" type="number" outlined :rules="rules.has_quantity" dense height="48" hide-details)
        div.ml-2(style="width: 200px")
          v-select.text-md.font-normal.mt-2.round-xl(v-model="durationUnit" :items="units" item-text="text" item-value="value" outlined :rules="rules.not_empty_select" attach dense height="48" hide-details)
            template(v-slot:append)
              eva-icon(name="chevron-down-outline" width="20" height="20" style="margin-top: 6px" :fill="$colors.basic700")

      div.text-md.font-medium.neutral700--text.mt-8 Slot interval
      div.d-flex.align-center
        div(style="width: 60px")
          v-text-field.text-md.font-normal.mt-2.round-xl.inputNumber.inputText(v-model="intervalValue" placeholder="30" type="number" outlined :rules="rules.has_quantity" dense height="48" hide-details)
        div.ml-2(style="width: 200px")
          v-select.text-md.font-normal.mt-2.round-xl(v-model="intervalUnit" :items="units" item-text="text" item-value="value" outlined :rules="rules.not_empty_select" attach dense height="48" hide-details)
            template(v-slot:append)
              eva-icon(name="chevron-down-outline" width="20" height="20" style="margin-top: 6px" :fill="$colors.basic700")

  v-row(no-gutters)
    v-col(cols="12")
      div.text-md.font-medium.neutral700--text.mt-8 {{ $t('service_photo_optional') }}
      div.text-sm.neutral500--text.mb-4 {{ $t('service_photo_desc') }}

      draggable.row.no-gutters(handle=".handle" draggable=".can-drag" :list="photos" @start="drag = true" @end="endMove" :move="checkMove")
        template(v-for="(photo, index) in photosWithLimit")
          v-col.can-drag(cols="4" sm="3" style="padding: 0 16px 16px 0")
            v-img.round-lg.handle.cursor-grab(:src="service ? photo.image.file : photo.fileUrl" aspect-ratio="1")
              v-overlay(v-if="isUpdating" absolute opacity="0.2")
                v-progress-circular(indeterminate color="white" size="30" width="2")
              .d-flex
                v-chip.px-2.text-xxs.ml-2.mt-3.chip-cover-photo(v-if="!service && index === 0" color="primary" label small) {{ $t('cover_photo') }}
                v-spacer
                v-menu(offset-y left rounded="lg")
                  template(v-slot:activator="{ on, attrs }")
                    v-btn.neutral100.mr-2.mt-3(icon v-on="on" small)
                      v-icon(color="neutral500" size="20") mdi-dots-vertical
                  v-list.text-sm.py-0
                    v-list-item(@click="makeCoverPhoto(index)")
                      div {{ $t('make_cover_photo') }}
                    v-divider.basic300
                    v-list-item(@click="deletePhoto(index)")
                      .danger--text {{ $t('delete_photo') }}

        template(v-if="service && service.product.image" slot="header")
          v-col(cols="4" sm="3" style="padding: 0 16px 16px 0")
            v-img.round-lg(:src="service.product.image.file" aspect-ratio="1")
              v-overlay(v-if="isUpdating" absolute opacity="0.2")
                v-progress-circular(indeterminate color="white" size="30" width="2")
              .d-flex
                v-chip.px-2.text-xxs.ml-2.mt-3.chip-cover-photo(color="primary" label small) {{ $t('cover_photo') }}
                v-spacer
                v-menu(offset-y left rounded="lg")
                  template(v-slot:activator="{ on, attrs }")
                    v-btn.neutral100.mr-2.mt-3(v-if="photos.length === 0" icon v-on="on" small)
                      v-icon(color="neutral500" size="20") mdi-dots-vertical
                  v-list.text-sm.py-0
                    v-list-item(@click="deleteCoverPhoto")
                      .danger--text {{ $t('delete_photo') }}
      
        template(slot="footer")
          v-col(v-if="service && !showAllPhotos && this.photos.length > limitPhotoCount" cols="4" sm="3" style="padding: 0 16px 16px 0")
            v-img.round-lg.cursor-pointer(:src="this.photos[limitPhotoCount - 1].image.file" aspect-ratio="1" @click="showAllPhotos = true")
              v-overlay(absolute opacity="0.8")
                .text-md All {{ photoCount }} photos
                
          v-col(cols="4" sm="3" style="padding: 0 16px 16px 0")
            v-card.round-3xl.file-layout(align="center" outlined)
              v-responsive(aspect-ratio="1")
                v-row.fill-height(align="center" justify="center")
                  v-progress-circular(v-if="isUploading" indeterminate color="primary" size="30" width="2")
                  div.text-sm.font-normal.info500--text(v-else)
                    v-icon.mb-1(color="info500" left size="20") $yzi-upload-01
                    | {{ $t('upload_photo') }}
                input.input-change-layout(ref="file" type="file" @change="onFileChange" accept="image/*")
  
  div.d-flex.mt-5
    v-spacer
    v-btn.round-lg.heading-6.px-8(v-if="service" color="neutral700" dark depressed height="48" :loading="isLoading" @click="saveData") {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'
import draggable from 'vuedraggable'

export default {
  name: 'ServiceDetails',
  components: { draggable },
  inject: ['getRef'],
  data () {
    return {
      isLoading: false,
      isUploading: false,
      isUpdating: false,
      displayServiceFee: false,
      name: null,
      description: null,
      durationValue: null,
      intervalValue: 30,
      priceDisplay: [],
      durationUnit: 'minutes',
      intervalUnit: 'minutes',
      priceType: 'fixed',
      units: [{ text: 'Minutes', value: 'minutes' }, { text: 'Hours', value: 'hours' }],
      types: [{ text: 'Fixed', value: 'fixed' }, { text: 'Range', value: 'range' }],
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        not_empty_select: [v => !!v || 'This field is required']
      },
      resizeImageFileUrl: '',
      resizeImageFile: null,
      photos: [],
      drag: false,
      moveParams: {},
      fromPhotoId: null,
      showAllPhotos: false,
      limitPhotoCount: 3
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      service: 'clinic/getService',
    }),
    detailsData () {
      if (!this.service) {
        return {
          product: {
            name: this.name,
            description: this.description
          },
          duration_value: this.durationValue,
          duration_unit: this.durationUnit,
          slot_interval_value: this.intervalValue,
          slot_interval_unit: this.intervalUnit,
          price_display: (this.displayServiceFee && this.priceDisplay.length > 0) ? this.priceDisplay.map(m => this.$currency.symbol + ' ' + m).toString().replace(',', ' - ') : null,
          price_type: this.priceType,
          photos: this.photos
        }
      }
      return null
    },
    photoCount () {
      let count = this.photos.length
      if (this.service && this.service.product.image) {
        return count + 1
      }
      return count
    },
    photosWithLimit () {
      if (this.photos.length > this.limitPhotoCount && !this.showAllPhotos && this.service) {
        const defaultPhotos = [...this.photos]
        return defaultPhotos.splice(0, this.limitPhotoCount - 1)
      }
      return this.photos
    }
  },
  mounted () {
    if (this.service) {
      this.setData(this.service)
      this.fetchImages()
    } else {
      this.$watch('detailsData', {
        deep: true,
        handler (val) {
          this.$store.commit('clinic/updateTempService', val)
        } 
      })
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (service) {
      this.name = service.product.name
      this.description = service.product.description
      this.durationValue = service.duration_value
      this.durationUnit = service.duration_unit
      this.intervalValue = service.slot_interval_value
      this.intervalUnit = service.slot_interval_unit
      this.priceDisplay = service.price_display ? service.price_display.replace(new RegExp(this.$currency.symbol, "g"), '').replace(/\s/g, '').split('-') : []
      this.priceType = service.price_type,
      this.displayServiceFee = Boolean(service.price_display)
    },
    fetchImages () {
      this.$axios.get(`/clinics/${this.company.slug}/services/${this.service.id}/images`)
        .then(resp => {
          this.photos = []
          resp.data.results.forEach(photo => {
            if (photo.image) {
              this.photos.push(photo)
            }
          })
        })
        .catch(() => {})
    },
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], `service_photo_${Date.now()}.jpeg`)
      if (this.service) {
        if (this.service.product?.image) {
          this.uploadPhoto(resizedImage.file)
        } else {
          this.uploadCoverPhoto(resizedImage.file)
        }
      } else {
        this.photos.push({
          fileUrl: resizedImage.dataURL,
          file: resizedImage.file
        })
      }
    },
    uploadPhoto (file) {
      const params = new FormData()
      params.append('image', file)
      this.isUploading = true
      this.$axios.post(`/clinics/${this.company.slug}/services/${this.service.id}/images`, params)
        .then(resp => {
          this.showAllPhotos = true
          this.photos.push(resp.data)
          this.showMessage(['success', this.$t('success_message.update_successful')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isUploading = false
        })
    },
    uploadCoverPhoto (file) {
      const params = new FormData()
      params.append('product.image', file)
      this.isUploading = true
      this.$axios.patch(`/clinics/${this.company.slug}/services/${this.service.id}`, params)
        .then(resp => {
          this.$store.commit('clinic/setService', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isUploading = false
        })
    },
    deletePhoto (index) {
      if (this.service) {
        this.isUpdating = true
        const photo = this.photos[index]
        this.$axios.delete(`/images/${photo.image.id}`)
          .then(() => {
            this.photos.splice(index, 1)
            this.showMessage(['success', this.$t('success_message.photo_deleted_successfully')])
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isUpdating = false
          })
      } else {
        this.photos.splice(index, 1)
      }
    },
    deleteCoverPhoto () {
      this.isUpdating = true
      this.$axios.delete(`/images/${this.service.product.image.id}`)
        .then(() => {
          this.service.product.image = null
          this.showMessage(['success', this.$t('success_message.photo_deleted_successfully')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isUpdating = false
        })
    },
    makeCoverPhoto (index) {
      const photo = this.photos[index]
      if (this.service) {
        this.isUpdating = true
        this.$axios.post(`/clinics/${this.company.slug}/services/${this.service.id}/cover_image`, { image: photo.image.id })
          .then(resp => {
            this.$store.commit('clinic/setService', resp.data)
            this.fetchImages()
            this.showMessage(['success', this.$t('success_message.update_successful')])
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isUpdating = false
          })
      } else {
        this.photos.splice(index, 1)
        this.photos.unshift(photo)
      }
    },
    saveData () {
      if (!this.getRef.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all')])
        return
      }
      this.isLoading = true
      const data = {
        product: {
            name: this.name,
            description: this.description
          },
        duration_value: this.durationValue,
        duration_unit: this.durationUnit,
        slot_interval_value: this.intervalValue,
        slot_interval_unit: this.intervalUnit,
        price_display: (this.displayServiceFee && this.priceDisplay.length > 0) ? this.priceDisplay.map(m => this.$currency.symbol + ' ' + m).toString().replace(',', ' - ') : null,
        price_type: this.priceType
      }
      const endpoint = `/clinics/${this.company.slug}/services/${this.service.id}`
      this.$axios.patch(endpoint, data)
        .then(resp => {
          this.updateActivityLog(endpoint, data, resp, 'PATCH', this.service.id)
          this.$store.commit('clinic/setService', resp.data)
          this.showMessage(['success', this.$t('success_message.update_successful')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    checkMove (e) {
      const fromPhoto = this.photos[e.draggedContext.index]
      const toPhoto = this.photos[e.draggedContext.futureIndex]
      if (!fromPhoto?.id || !toPhoto?.id) {
        return
      }
      this.moveParams = {
        position: e.draggedContext.futureIndex,
        targetId: toPhoto.id
      }
      this.fromPhotoId = fromPhoto.id
    },
    endMove () {
      this.drag = false
      if (!this.fromPhotoId || !this.service) {
        return
      }
      if (this.fromPhotoId === this.moveParams.targetId) {
        return
      }
      this.$axios.post(`/clinics/${this.company.slug}/services/${this.service.id}/images/${this.fromPhotoId}/move/`, this.moveParams).catch(() => {})
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'service',
        activity: 'Update service (service details)',
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.file-layout {
  position: relative;
  cursor: pointer;
  border: var(--v-neutral400) dashed 1px;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.inputNumber >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.inputText >>> input {
  margin-top: 3px;
  text-align: center;
}
.chip-cover-photo {
  height: 20px;
  opacity: 0.8;
}
</style>